import { API_TBase } from "@/models/API";

export type API_TSponsorshipCandidate = {
  first_name: string;
  last_name: string;
  email: string;
};

export type TSponsorshipCandidates_Table = {
  id: number;
  name: string;
  email: string;
};

export type API_TSponsorship_candidates = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
} & API_TBase;

const convertToString = (section: string | number | null) => {
  return section?.toString() || "—";
};

const getFullName = (first_name?: string, last_name?: string): string => {
  if (!first_name && !last_name) return "";
  let value = "";

  if (first_name) value += first_name;

  if (last_name) value += ` ${last_name}`;

  return value;
};

export const convertSponsorshipCandidatesForTable = (
  a: API_TSponsorship_candidates
): TSponsorshipCandidates_Table => {
  const name = getFullName(a.first_name, a.last_name);

  return {
    id: a.id,
    name,
    email: convertToString(a.email),
  };
};
